<script setup lang="ts">
import { defineProps, withDefaults, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProgressSpinner from 'primevue/progressspinner';

const { t } = useI18n();

const props = withDefaults(defineProps<{
  message?: string;
}>(), {
  message: undefined
});

const displayMessage = computed(() => props.message || t('processing'));
</script>

<template>
  <div class="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-gray-400 bg-opacity-70 backdrop-blur-sm">
    <div class="flex flex-col items-center">
        <ProgressSpinner />
      <p class="mt-4 text-white text-xl font-medium">{{ displayMessage }}</p>
    </div>
  </div>
</template>

<style scoped>
/* You can add extra customizations here if desired */
</style>
